import { context, Gain, start, ToneAudioBuffers, ToneBufferSource, now } from 'tone';

import tb303RunClearRandom from '../assets/sounds/sfx/303runclearrandom.mp3';
import tb303WaveformSwitch from '../assets/sounds/sfx/303waveformswitch.mp3';
import tr808AISwitch from '../assets/sounds/sfx/808AIswitch.mp3';
import tr808Clear from '../assets/sounds/sfx/808clear.mp3';
import tr808FillIn from '../assets/sounds/sfx/808fillin.mp3';
import tr808StartStop from '../assets/sounds/sfx/808startstop.mp3';
import countdown1 from '../assets/sounds/sfx/countdown1.mp3';
import countdown2 from '../assets/sounds/sfx/countdown2.mp3';

let sfxBuffers = new ToneAudioBuffers({
    tb303RunClearRandom,
    tb303WaveformSwitch,
    tr808AISwitch,
    tr808Clear,
    tr808FillIn,
    tr808StartStop,
    countdown1,
    countdown2
});
let sfxGain = new Gain(0.5).toDestination();

export function triggerTR808StartStop() {
    trigger('tr808StartStop');
}

export function triggerTB303RunClearRandom() {
    trigger('tb303RunClearRandom');
}

export function triggerTB303WaveformSwitch() {
    trigger('tb303WaveformSwitch');
}

export function triggerTR808AISwitch() {
    trigger('tr808AISwitch');
}

export function triggerTR808Clear() {
    trigger('tr808Clear');
}

export function triggerTR808FillIn() {
    trigger('tr808FillIn');
}

export function triggerCountdownUp(time: number) {
    trigger('countdown2', time);
}

export function triggerCountdownDown(time: number) {
    trigger('countdown1', time);
}

async function trigger(sampleName: string, time = now()) {
    if (context.state !== 'running') await start();

    let buf = sfxBuffers.get(sampleName);
    if (buf?.loaded) {
        let src = new ToneBufferSource(buf).connect(sfxGain);
        src.start(time);
        src.onended = (() => src.dispose());
    }
}